export const DS_NUMBER_FIELD_CLASSES = {
  Root: "ds-number-field",
  InputRow: "ds-number-field__input-row",
  Input: "ds-number-field__input",
  HiddenInput: "ds-number-field__hidden-input",
  Controls: "ds-number-field__controls",
  ControlButton: "ds-number-field__control-button",
  Decrement: "ds-number-field__decrement",
  Increment: "ds-number-field__increment",
} as const;
